import React, { useCallback } from "react";
import { Spinner, Tag, Tooltip } from "@blueprintjs/core";
import "styled-components/macro";
import { useBoolean } from "../../helpers/useBoolean";
import { useStoreActions } from "../../hooks/ep";

export function SsdashEmailActionButtonCellRenderer({
  data,
  value,
  crp,
}: {
  data: any;
  value: string;
  crp: { tooltipText?: string };
}) {
  const isLoading = useBoolean(false);
  const handleFetchMailtoLink = useStoreActions(
    (a) => a.misc.handleFetchMailtoLink
  );

  const studentIndex = data["StudentIndex"];

  const onClickFactory = useCallback(
    (emailTemplateId) => async () => {
      if (isLoading.value) {
        return;
      }
      isLoading.setTrue();
      await handleFetchMailtoLink({
        entityType: "student",
        entityId: studentIndex,
        emailTemplateId,
      });
      isLoading.setFalse();
    },
    // eslint-disable-next-line
    [studentIndex, handleFetchMailtoLink]
  );

  const onClick = onClickFactory("ssdash_risk");
  const isDisabled = isLoading.value;

  return (
    <span>
      <Tooltip
        content={"Compose email from template"}
        boundary="viewport"
        hoverOpenDelay={1500}
        hoverCloseDelay={0}
        isOpen={isLoading.value ? false : null}
      >
        <Tag
          css={`
            font-size: 12px;
            height: 26px;
            & .bp3-icon,
            & .bp3-spinner {
              margin-right: 6px;
            }
          `}
          fill={true}
          minimal={true}
          intent={isDisabled ? "none" : "primary"}
          large={false}
          onClick={onClick}
          icon={
            isLoading.value ? <Spinner size={Spinner.SIZE_SMALL} /> : "envelope"
          }
          interactive={!isDisabled}
          disabled={isDisabled}
        />
      </Tooltip>
    </span>
  );
}
